@let hasShiftCreatePermission =
  can(RoleAction.Create, RolePermissionSubject.Shift);
<div class="d-flex">
  @for (
    shiftTemplate of suggestedShiftTemplates$ | async;
    track shiftTemplate
  ) {
    <div
      class="shift-card d-flex align-items-center text-truncate me-2"
      [style.border-left]="'4px solid ' + shiftTemplate.colorCode"
      [class.hide-card]="!isQuickCreationCardOpen"
      [class.not-allowed]="!hasShiftCreatePermission"
      [draggable]="hasShiftCreatePermission"
      (dragstart)="startDrag(shiftTemplate)"
      (dragend)="dragEnd()"
      nz-tooltip
      [nzTooltipTitle]="
        hasShiftCreatePermission
          ? shiftTemplate.name
          : ('general.forbidden_action' | translate)
      "
      nzTooltipPlacement="top"
      [attr.data-test-id]="
        'wilson-shift-quick-creation-from-template-card:shift-template-card:' +
        shiftTemplate.id
      "
    >
      <div class="d-block">
        <p class="mb-2 fw-normal text-dark card-text text-truncate">
          {{ shiftTemplate.name }}
        </p>
        <div class="d-flex">
          <div class="activity-card-sm"></div>
          <div class="activity-card-sm"></div>
          <div class="activity-card-lg"></div>
        </div>
      </div>
    </div>
  }
</div>
